// TODO: add env variable
export const BASE_WS_URL = "wss://music-mafia.ru/api/";
export const BASE_HTTPS_URL = "https://music-mafia.ru/api/";

// export const BASE_WS_URL = 'ws://localhost:8000/';
// export const BASE_HTTPS_URL = 'http://localhost:8000/';
